<template>
  <edition-panel ref="editionPanel" v-if="editionName !== 'Edición crítica'" :side="side">
    <div class="col d-flex flex-column align-items-center">
      <div>Edición/Testimonio</div>
      <b-form-select v-model="editionName" :options="editionNames"/>
    </div>
  </edition-panel>
  <base-edition-panel ref="baseEditionPanel" v-else :side="side">
    <div class="col d-flex flex-column align-items-center">
      <div>Edición/Testimonio</div>
      <b-form-select v-model="editionName" :options="editionNames"/>
    </div>
  </base-edition-panel>
</template>
<script>
  import {mapState, mapGetters} from 'vuex'
  import EditionPanel from './EditionPanel'
  import BaseEditionPanel from './BaseEditionPanel'

  export default {
    components: {EditionPanel, BaseEditionPanel},
    props: {
      side: {type: String, required: true}
    },
    computed: {
      ...mapState({document: s => s.document}),
      ...mapGetters(['editionNames']),
      editionName:{
        get() {
          return this.$store.state[this.side].editionName
        },
        set(name) {
          this.$store.commit('setEditionName', {side: this.side, name})
        }
      }
    }
  }
</script>